const keys = {
  up: 38,
  left: 37,
  down: 40,
  right: 39,
  space: 32,
  enter: 13,
  esc: 27,
  tab: 9,
  home: 36,
  end: 35,
} as const;

export default keys;
